var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.652,
    height: 19.77,
    viewBox: "0 0 20.652 19.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share",
    transform: "translate(-314.748 358.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    d: "M336.25-352.282c-1.805 2.291-3.121 6.393-2.684 8.509 2.224-4.514 5.178-7.879 10.785-7.487l.105 2.066 5.532-4.435-5.625-4.461v2.495c-5.141.637-6.42 1.164-8.113 3.313z",
    className: "cls-1",
    transform: "translate(-14.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    d: "M330.238-339.26v8.124a.152.152 0 0 1-.152.152h-13.3a.152.152 0 0 1-.152-.152v-13.083a.152.152 0 0 1 .152-.152h4.847a8.532 8.532 0 0 1 4.192-1.882h-9.039a2.036 2.036 0 0 0-2.034 2.034v13.083a2.036 2.036 0 0 0 2.034 2.034h13.3a2.036 2.036 0 0 0 2.034-2.034v-9.633z",
    className: "cls-1",
    transform: "translate(0 -9.218)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.17f8d670d3bf1fd345dc439e18f1e777.svg";
export { ForwardRef as ReactComponent };